import { UPDATE_FORM_TWO, DELETE_FORM_TWO } from './types';


export function FormTwoReducer(state, action) {

    const { payload, type } = action


    switch (type) {

        case UPDATE_FORM_TWO:
            return {
                ...state,
                formTwo: payload
            }

        case DELETE_FORM_TWO:
            return {
                ...state,
                formTwo: payload
            }
        default:
            break;
    }

} 